export type FieldId = string;
export type FieldName = string;
export type FieldTypes = FieldType.Predefined
    | FieldType.Text
    | FieldType.Number
    | FieldType.Date
    | FieldType.Dropdown
    | FieldType.Multi_Selector
    | FieldType.HTML_Editor
    | FieldType.Toggle
    | FieldType.Address
    | FieldType.KVK
    | FieldType.Combination;

export enum CANDIDATE_PREDEFINED {
    EXPERIENCE = 'f675817e-7e8e-476f-b664-d5c42907bd33',
    EDUCATION = 'b0dc65a4-2c0f-4de9-8a0f-e3a619fb33d6',
    COURSE = 'c0c33819-ff5f-4886-93ed-ec91b60124a0',
    PROJECT = '14139bf2-0c0d-4978-9246-c8fab452a410'
};

export enum FieldType {
    Predefined = -100,
    
    MultiSelect = -2,
    Select = -1,
    
    Text = 1,
    Number = 2,
    Date = 3,
    Dropdown = 4,
    Multi_Selector = 5,
    HTML_Editor = 6,
    Toggle = 7,
    Address = 8,
    KVK = 9,
    Combination = 10,
    Radio = 11
}
export const getFieldTypeLabel = (type: FieldTypes) => {
    switch (type) {
        case FieldType.Predefined:
            return 'Predefined';
        case FieldType.Text:
            return 'Tekst';
        case FieldType.Number:
            return 'Nummer';
        case FieldType.Date:
            return 'Datum';
        case FieldType.Dropdown:
            return 'Dropdown';
        case FieldType.Multi_Selector:
            return 'Multi Selector';
        case FieldType.HTML_Editor:
            return 'HTML Editor';
        case FieldType.Toggle:
            return 'Toggle';
        case FieldType.Address:
            return 'Adres';
        case FieldType.KVK:
            return 'KVK';
        case FieldType.Combination:
            return 'Combinatie';
        default:
            return 'Type: ' + type + ' is not supported';
    }
} 
export type FieldDefault = string | number;
export type FieldOrder = number;
export type FieldRequired = boolean;
export type FieldStatuses = FieldStatus.Active | FieldStatus.Inactive;
export enum FieldStatus {
    Inactive = 0,
    Active = 1
}

export interface FieldProps {
    id: FieldId;
    name: FieldName;
    type: FieldTypes;
    default: FieldDefault;
    order?: FieldOrder;
    required: FieldRequired;
    status?: FieldStatuses;
}

export interface Fields {
    candidate: {
        unsaved: FieldProps[],
        saved: FieldProps[]
    },
    vacancy: {
        unsaved: FieldProps[],
        saved: FieldProps[]
    }
}


export type DatasetId = number;
export type DatasetValue = string;

export interface DatasetNode {
    [id: number]: {
        value: DatasetValue,
        children?: DatasetNode
    }
}

export interface Dataset {
    [id: number]: {
        value: DatasetValue,
        children?: DatasetNode
    } 
}

export interface FieldManagement {
    values: any;
    layouts: any;
    fields: any;
    relations: any;
    datasets: any;
}